import { AxiosRequestConfig } from "axios";
import ApiConstants from "../constants/ApiConstants";
import http from "../http";


class BooksIntegrationService {

    static apiConfig;
    static getPayruns() {
        let params = this.apiConfig;
        let url = ApiConstants.URL.PAYROLL.GET_PAYROLL;
        if (params) {
            let paramStr = '';
            let keys = Object.keys(params);
            keys.forEach((key, index) => {
                if (index == 0) {
                    paramStr = `?${[key]}=${params[key]}`
                } else {
                    paramStr = paramStr + `&${[key]}=${params[key]}`
                }

            })
            url = url + paramStr
        }
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading report ', err);
                return Promise.reject(err);
            });
    }
    static revert(param){
        let url = `${ApiConstants.URL.PAYROLL.GET_PAYROLL}/revert-je`;
        return http.post(url,param)
    }
    static sync(param){
        let url = `${ApiConstants.URL.PAYROLL.GET_PAYROLL}/sync-je`;
        return http.post(url,param)
    }
    static integrationSave(param){
        let url = `${ApiConstants.URL.BASE + ApiConstants.URL.PEOPLE.TENANT}/update/integration-mapping`
        return http.put(url,param);
    }
}

export default BooksIntegrationService;
